import React from 'react';
import PatientQueue from './PatientQueue';

const AllPatientsQueue = () =>
	<PatientQueue
		patientNameWithStatusColumn
		providerDetailColumn
		myPatientBillingColumn
		lastWorkedHistoryColumn
		showScheduleCallFilter
		showClinicalServiceGoalFilter
		showRpmEligibilityFilter
		showFilters
		myPatientStatusColumn
		chartColumn
		lastWorkedByColumn
		page
		queue="allPatients"
		endpoint="All"
		label="All Patients"
		lastContactColumn
		showUrgentFilter
		rowHeight={150}
		hideAssignee
	/>;

export default AllPatientsQueue;
